

































export default {
  name: 'KnowledgeHub',
  data(): { videoOpen: boolean; videos: { title: string; url: string }[] } {
    return {
      videoOpen: true,
      videos: [
        { title: 'Erste Schritte und Stammdaten anlegen', url: 'https://www.youtube.com/watch?v=mhuFnO4w5ms' },
        { title: 'Alarme einrichten', url: 'https://www.youtube.com/watch?v=HuqvkC_Br7c' },
      ],
    };
  },
  methods: {
    openHandbuch(): void {
      window.open('/files/2026_06_VF_IW_GK4.0_Handbuch_Kundenversion.pdf', '_blank');
    },
    openVideo(url: string): void {
      window.open(url, '_blank');
    },
  },
};
